<section class="banner-section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="banner-title">
                    <div class="title"><h1>Verificador Gramatical Online Gratuito</h1></div>
                    <p>Corrija instantaneamente a sua escrita com o verificador gramatical gratuito Trinka desenvolvido por IA.<br /> Trinka permite que você aprimore a sua escrita além da gramática básica, com sugestões para escolha de palavras, sons e muito mais.</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="multiTabSection">
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#EnglishGrammarChecker" role="tab">English</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#SpanishGrammarChecker" role="tab">Spanish</a>
                        </li>
                        <!-- <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#GermanGrammarChecker" role="tab">German</a>
                        </li> -->
                    </ul><!-- Tab panes -->
                    <div class="tab-content">
                        <div class="tab-pane active" id="EnglishGrammarChecker" role="tabpanel">
                            <app-english-grammar-checker></app-english-grammar-checker>
                        </div>
                        <div class="tab-pane" id="SpanishGrammarChecker" role="tabpanel">
                            <app-spanish-grammar-checker></app-spanish-grammar-checker>
                        </div>
                        <!-- <div class="tab-pane" id="GermanGrammarChecker" role="tabpanel">
                            <app-german-grammar-checker></app-german-grammar-checker>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <span class="shape-1"></span>
    <span class="shape-2"></span>
    <span class="shape-3"></span>
</section>

<div class="gcBrowserSection">
    <div class="container">
        <div class="row">
            <div class="gcBrowserContainer">
                <div class="col-sm-12 col-md-8 col-lg-9">
                    <h2>Obtenha verificação de gramática em tempo real nos seus Web sites favoritos GRATUITAMENTE!</h2>
                </div>
                <div class="col-sm-4 col-md-4 col-lg-3 text-center">
                    <a  id="GCChromeButton" href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank"><img src="../../../assets/images/NewChromeIcon.svg" alt="chrome">Instalar en Chrome</a>
                    <a  id="GCFirFoxButton" href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai/" target="_blank"><img src="../../../assets/images/NewFirefoxIcon.svg" alt="firefox">También disponible en Firefox</a>
                    <a  id="GCEdgeButton" href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank"><img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="edge">Instalar en Edge</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="signupmobile" style="display: none !important;">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="trinkaPluginGCSection">
                    <h2>Sua conta gratuita no Trinka</h2>
                    <P>Verifique até 10.000 palavras da sua escrita todo mês e note uma melhoria geral na sua linguagem e estilo.</P>
                    <a href="https://cloud.trinka.ai/signup?_rg=GB" target="_blank">Inscreva-se JÁ!</a>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- 
<div class="trinka_demo_wrap gcBannerSection">
    <div class="see_trinka_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="top_heading howItWorkHeading lineWhiteColor">
                        <h1>Verificador Gramatical Online Gratuito</h1>
                        <div class="HeadingSubLine"></div>
                        <p>Corrija instantaneamente a sua escrita com o verificador gramatical gratuito Trinka desenvolvido por IA.<br /> Trinka permite que você aprimore a sua escrita além da gramática básica, com sugestões para escolha de palavras, sons e muito mais.</p>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-lg-7 col-md-9 col-sm-12 col-12">
                    <div class="gcResultSection">
                        <div class="trinkaPluginGCSection">
                            <p>Estamos atualizando a nossa ferramenta Free Grammar Checker (Verificador Gramatical Gratuito), motivo pelo qual ela não está disponível no momento. Entretanto, isso não deve impedi-lo de escrever.</p>
                            <p>Inscreva-se e use o nosso editor online gratuito, que verifica a sua redação em até 10.000 palavras, todos os meses, e possui recursos especiais adicionais:</p>
                            <div class="text-center"><a href="https://cloud.trinka.ai/signup?ref=PT-GC" target="_blank">Inscreva-se AGORA!</a></div>
                            <h3 class="text-center">Características especiais:</h3>
                            <div class="row">
                                <div class="col-md-10 offset-md-1">
                                    <ul class="row">
                                        <li class="col-lg-6 col-sm-6 col-12">Erros de gramática e ortografia</li>
                                        <li class="col-lg-6 col-sm-6 col-12">Escolha de palavras</li>
                                        <li class="col-lg-6 col-sm-6 col-12">Aprimoramento do idioma</li>
                                        <li class="col-lg-6 col-sm-6 col-12">Aconselhamento sobre a escrita</li>
                                        <li class="col-lg-6 col-sm-6 col-12">Guias de estilo</li>
                                        <li class="col-lg-6 col-sm-6 col-12">Dicionário personalizado</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->


<div class="the_best_grammer_sections">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="top_best_grammer_heading">
                    <h2>O Melhor Verificador Gramatical Online Gratuito</h2>
                    <div class="HeadingSubLine"></div>
                    <p>Trinka é um verificador gramatical e assistente de redação de aprimoramento de linguagem gratuito desenvolvido por IA, projetado para redação acadêmica e técnica. Além de verificações gramaticais avançadas, Trinka aprimora a sua redação quanto ao vocabulário, som, sintaxe e muito mais. Trinka oferece mais de 3.000 verificações gramaticais e correções ortográficas contextuais instantaneamente, permitindo que você melhore a sua escrita em minutos.</p>
                    <p>Trinka fornece sugestões de escrita em tempo real e verificações gramaticais avançadas para auxiliar profissionais e acadêmicos a garantir uma escrita formal, concisa e engajada. O verificador gramatical Trinka é treinado em milhões de documentos e artigos bem escritos que abrangem mais de 1.300 áreas, incluindo medicina, ciências biológicas, ciências físicas, engenharia, humanas, negócios e artes para dar a você as sugestões mais relevantes para o seu assunto. </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="grammarCheckSection">
    <div class="container">
        <div class="row">
            <div class="col-md-4">
                <div class="grammarCheckHeadingSection">
                    <h2> Quem pode usar o Verificador Gramatical?</h2>
                </div>
            </div>
            <div class="col-md-8">
                <div class="grammarCheckTextContent">
                    <p>Trinka é ideal para quem procura melhorar as suas habilidades de escrita em inglês. A ferramenta de verificação gramatical gratuita Trinka tem a confiança de acadêmicos, redatores, profissionais de marketing, equipes de produto, blogueiros e muito mais.</p>
                </div>
            </div>
        </div> 
    </div>
</div>

<div class="the_best_grammer_sections">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="top_best_grammer_heading">
                    <h2>Trinka é mais do que apenas um Verificador de Gramática Básica e de Pontuação</h2>
                    <div class="HeadingSubLine"></div>
                    <!-- <p>Enhance and check your writing instantly with the best English grammar checker. Trinka's advanced
                        checking feature highlights mistakes and provides contextual suggestions that make your writing
                        rise and shine.</p> -->
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="best_grammer_cards">
                    <h3>Verificador de Gramática Avançada</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>
                                Trinka vai além das verificações gramaticais e ortográficas básicas e verifica a sua escrita em busca de erros gramaticais avançados,  sugerindo aprimoramentos de linguagem para garantir uma melhoria holística em sua qualidade de escrita.</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Technical word choice</h4> -->
                            <p>Neither the healthy individuals nor the patient <span
                                class="wrong_text">recognize</span> <span
                                class="right_text"> recognizes</span> the visual discrepancies.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="best_grammer_cards">
                    <h3>Estrutura da Frase</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>O corretor de frases Trinka ajuda a estruturar melhor as suas frases com base no assunto, tornando a sua escrita mais fácil de ser lida pelo público.</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Syntax</h4> -->
                            <p>The students don't enjoy <span class="wrong_text">to go</span> <span
                                class="right_text"> going</span> over the same rules again and again.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="best_grammer_cards">
                    <h3>Escolha da Palavra</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinka corrige os erros na escolha de palavras que tornam a sua escrita confusa. Comunique a sua intenção de forma clara e precisa com Trinka.</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Advance Spelling</h4> -->
                            <p>One of the reasons is <span class="wrong_text">because</span> <span
                                class="right_text"> that</span> the fabrication cost <span
                                class="wrong_text">for</span> <span class="right_text"> of</span> steel
                            members depends upon the material.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="best_grammer_cards">
                    <h3>Verificador Ortográfico Avançado</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>O corretor ortográfico gratuito Trinka entende o contexto da sua escrita e o ajuda  a escolher a palavra correta para o seu tópico. Não há mais erros estranhos de ortografia!</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Sensitive language</h4> -->
                            <p>The <span class="wrong_text">Bonferoni</span> <span
                                class="right_text"> Bonferroni</span> test was used to check for
                            statistical significance.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="use_trinka_other_app">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="use_trinka_content">
                    <div class="use_trinka_heading">
                        <div class="howItWorkHeading lineWhiteColor">
                            <h2>Use a Trinka em outros aplicativos</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                    </div>
                    <div class="others_app_name">
                        <ul>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/trinkacloud']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka cloud">
                                        <h3>Cloud</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/wordplugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/wordAdd_in.svg" alt="word addin">
                                        <h3>MS Word</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/NewChromeIcon.svg" alt="chrome">
                                        <h3>Chrome</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/NewFirefoxIcon.svg" alt="firefox">
                                        <h3>Firefox</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="edge">
                                        <h3>Edge</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <span class="safariComingSoonTag">em breve</span>
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/safari_logo.png" alt="safari logo">
                                        <h3>Safari</h3>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="moreEffectiveSection">
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <div class="moreEffectiveImages">
                    <img src="../../../assets/images/WritingMoreEffective.png" alt="effective writing">
                </div>
            </div>
            <div class="col-md-6">
                <div class="moreEffectiveTextContent">
                    <h2>Torne a sua escrita mais eficaz com o verificador gramatical Trinka</h2>
                    <p>O verificador gramatical Trinka verifica a sua escrita e melhora as suas frases de forma holística - quanto ao som, estrutura, escolha de palavras e legibilidade - ao contrário de outros verificadores gramaticais. Otimize o seu fluxo de trabalho com o nosso verificador gramatical profissional - ele incorpora três produtos em um só. Obtenha um verificador de frases,  de ortografia e de pontuação.</p>
                    <p>Adquire mais do que apenas um verificador gramatical e certifique-se de que a sua redação esteja clara e concisa.</p>
                </div>
            </div>
        </div>
        <div class="row colunmChangesSection">
            <div class="col-md-6">
                <div class="moreEffectiveTextContent">
                    <h2>Aprenda gramática com o Verificador Gramatical Trinka</h2>
                    <p>Cada correção gramatical é uma oportunidade de aprendizado. O verificador gramatical Trinka não apenas destaca os erros, mas também explica como corrigí-los, ajudando-o  a se tornar um redator melhor. Você também obtém uma pontuação indicativa da qualidade geral da linguagem do conteúdo.</p>
                    <p>Por meio do verificador gramatical Trinka, os alunos podem aprender a escrever de forma eficaz e a implantar melhores práticas de escrita. </p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="moreEffectiveImages">
                    <img src="../../../assets/images/LearnGrammarwithTrinka.png" alt="learn grammar">
                </div>
            </div>
        </div>
    </div>
</div>

<section class="section-md gc-testimonials-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center testi">
                <div class="GCTestmonials">
                    <h2>Depoimentos</h2>
                    <div class="HeadingSubLine"></div>          
                </div>
            </div>
        </div>
    </div>
    <div class="testimonial text-center">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="testimonial-wrap">
                        <!-- <div class="testimonal-icon">
                            <img src="../../../assets/images/testimonial.png" alt="grammar-checker-testimonial">
                        </div> -->
                        <div class="testimonial-slider">
                            <div id="testi" class="carousel slide" data-ride="carousel">
                                <ol class="carousel-indicators">
                                    <li data-target="#testi" data-slide-to="0" class="active"></li>
                                    <li data-target="#testi" data-slide-to="1"></li>
                                    <li data-target="#testi" data-slide-to="2"></li>
                                    <li data-target="#testi" data-slide-to="3"></li>
                                    <li data-target="#testi" data-slide-to="4"></li>
                                    <li data-target="#testi" data-slide-to="5"></li>
                                    <li data-target="#testi" data-slide-to="6"></li>
                                    <li data-target="#testi" data-slide-to="7"></li>
                                    <li data-target="#testi" data-slide-to="8"></li>
                                    <li data-target="#testi" data-slide-to="9"></li>
                                    <li data-target="#testi" data-slide-to="10"></li>
                                    <li data-target="#testi" data-slide-to="11"></li>
                                    <li data-target="#testi" data-slide-to="12"></li>
                                </ol>
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/James-Smith.jfif" alt="james smith">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Primeiramente, eu amo Trinka. Parabéns por desenvolverem algo que ajuda amplamente
                                                        na edição, especialmente convenções gramaticais críticas e reduções na
                                                        contagem de palavras.
    
                                                    </p>
                                                    <p class="authorNameText">James Smith</p>
                                                    <span class="authorDesignationText">Editor Acadêmico, EUA</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Rosa-Diaz-Sandoval.jfif" alt="Rosa-Diaz-Sandoval">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Escrever textos com gramática e estilo corretos em inglês não é uma tarefa
                                                        fácil para pessoas que falam outros idiomas. Às vezes, você não consegue
                                                        encontrar pequenos erros em seu documento sem ajuda, especialmente para
                                                        redação acadêmica. Experimentei Trinka Al como ferramenta de correção
                                                        automática e fiquei bastante satisfeita com as correções sugeridas e
                                                        o feedback. Com o feedback você entende porque a mudança sugerida deve
                                                        ser levada em consideração.</p>
                                                    <p class="authorNameText">Rosa Diaz Sandoval</p>
                                                    <span class="authorDesignationText">PhD em Física e Matemática, México</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Dr_Farooq_Rathore.jpg" alt="farooq rathore" />
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Uso trinka especialmente para melhorar a linguagem, gramática e sintaxe dos
                                                        manuscritos científicos que escrevo para periódicos biomédicos nacionais
                                                        e internacionais. Achei a interface amigável e o procedimento, em si,
                                                        é eficiente e descomplicado. As diferentes opções para para editar o
                                                        manuscrito conforme às necessidades me ajudam a decidir em qual área
                                                        devo focar. A edição automática é de grande ajuda e a página suplementar
                                                        com o resumo da revisão é uma excelente idéia. </p>
                                                    <p class="authorNameText">Dr. Farooq Rathore</p>
                                                    <span class="authorDesignationText">Professor Assistente e Chefe de Departamento, Paquistão</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Georgieva-Milena.jpg" alt="Georgieva-Milena">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Trinka Al é a minha escolha favorita para edição gramatical e ortográfica.
                                                        A plataforma funciona corretamente, é rápida e organizada! Estou completamente
                                                        satisfeita!
                                                    </p>
                                                    <p class="authorNameText">Milena Georgieva</p>
                                                    <span class="authorDesignationText">Pesquisador</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Dinesh-Gupta.jfif" alt="dinesh gupta">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">A ferramenta de verificação gramatical supera o Grammarly! Verifiquei novamente
                                                        alguns documentos que havia verificado anteriormente com o Grammarly.
                                                        Fiquei agradavelmente surpreso ao me deparar com tal produto originário
                                                        da Índia.
                                                    </p>
                                                    <p class="authorNameText">Dinesh Gupta</p>
                                                    <span class="authorDesignationText">Radiologista, Índia</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Edith-Davies.jpg" alt="Edith-Davies">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Testei Trinka e fiquei impressionada com suas excelentes capacidades. Trinka
                                                        é melhor do que o verificador gramatical que uso. Parabéns! Falei para
                                                        os meus colegas de laboratório de pesquisa para usarem Trinka. Espero
                                                        que Trinka seja usado amplamente no meio acadêmico.
                                                    </p>
                                                    <p class="authorNameText">Edith Davies</p>
                                                    <span class="authorDesignationText">Bolsista de Doutorado, Reino Unido</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Noor-Al-rishi.png" alt="noor-al-rishi">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">As correções e feedback sugeridos por Trinka Al me surpreenderam. É simples
                                                        de usar e extremamente benéfico.
                                                    </p>
                                                    <p class="authorNameText">Noor Al-rishi</p>
                                                    <span class="authorDesignationText">Bolsista de Química, Arábia Saudita</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Nwaji-Jude.jpg" alt="Nwaji-Jude">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Tem sido uma experiência maravilhosa usar Trinka e quase não consigo enviar
                                                        nenhum manuscrito sem que seja verificado por ele. Em resumo, Trinka
                                                        tem sido um salva-vidas.
                                                    </p>
                                                    <p class="authorNameText">Nwaji Jude</p>
                                                    <span class="authorDesignationText">Pesquisador</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Stumpf-Curtis.jfif" alt="stumpf curtis">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Gosto de usar Trinka como verificação final para meus documentos editados.
                                                        Trinka realmente ajuda a encontrar erros remanescentes que escapam durante
                                                        a primeira verificação. Gosto muito desta plataforma. O botão do polegar
                                                        para baixo é muito útil.
    
                                                    </p>
                                                    <p class="authorNameText">Stumpf Curtis</p>
                                                    <span class="authorDesignationText">Pesquisador</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Dyke-Gareth.jfif" alt="dyke gareth">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Acho Trinka Al uma ideia muito interessante e potencialmente útil, especialmente
                                                        para editores/periódicos. Eu achei trinka muito útil quando verifiquei
                                                        o meu trabalho de edição na plataforma.
                                                    </p>
                                                    <p class="authorNameText">Gareth Dyke</p>
                                                    <span class="authorDesignationText">Pesquisador</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Bhargava-Sharma.jfif" alt="bhargava sharma">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Estou feliz com o desempenho geral. Uso Grammarly faz muito tempo, mas quando
                                                        se trata de redação acadêmica ou técnica, Trinka é definitivamente uma
                                                        opção melhor. As configurações de documentos acadêmicos e a edição automática
                                                        de arquivos são os meus recursos favoritos.
                                                    </p>
                                                    <p class="authorNameText">Bhargava Sharma</p>
                                                    <span class="authorDesignationText">Epidemiologista, Índia</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Ralph-Bailey.jfif" alt="ralph bailey">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Trinka tornou-se minha ferramenta favorita para correções gramaticais. As
                                                        correções com inteligência artificial e os aprimoramentos de linguagem
                                                        tornaram a escrita muito mais fácil. Agora, posso me concentrar mais
                                                        na pesquisa do que em escrever um documento livre de erros.
                                                    </p>
                                                    <p class="authorNameText">Ralph Bailey</p>
                                                    <span class="authorDesignationText">Neurologista, EUA</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Thomas-Andres.jfif" alt="thomas andres">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">A correção gramatical e a sugestão com base no guia de estilo da AMA são
                                                        realmente impressionantes! Trinka é, de fato, a melhor ferramenta de
                                                        correção gramatical para redação médica.
    
                                                    </p>
                                                    <p class="authorNameText">Thomas Andres</p>
                                                    <span class="authorDesignationText">Cardiologista, Brasil</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                </div>
                            </div>
                            <!-- <a class="carousel-control-prev" href="#testi" data-slide="prev">
                                <span class="carousel-control-prev-icon"></span>
                            </a>
                            <a class="carousel-control-next" href="#testi" data-slide="next">
                                <span class="carousel-control-next-icon"></span>
                            </a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<div class="ready_to_levelUp">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="level_up_heading">
                    <h3>Receba um orçamento personalizado</h3>
                    <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank" id="grammerSignUpButton">
                        <span>Solicitar uma Demonstração</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="grammarCheckQuestions" style="margin-top: 80px;">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="GCQuestions">
                    <h2>Perguntas Frequentes sobre o Verificador Gramatical Trinka</h2>
                    <div class="HeadingSubLine"></div>          
                </div>
                <div class="row">
                    <div class="offset-md-1 col-md-10">
                        <div class="answersSections">
                            <div class="accordion" id="QeustionGrammarChecks">
                                <div class="card">
                                    <div class="card-header" id="QuestionGCOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCOneContent" aria-expanded="true"
                                            aria-controls="QuestionGCOneContent">
                                            Como o Trinka se compara a outros verificadores gramaticais online gratuitos?</a>
                                    </div>
        
                                    <div id="QuestionGCOneContent" class="collapse show"
                                        aria-labelledby="QuestionGCOne" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p><b>Testamos 5.778 palavras de cinco domínios acadêmicos em outros verificadores gramaticais gratuitos.</b> Verificamos a precisão das correções, preferências do guia de estilo, concisão e verificações ortográficas contextuais - e nos destacamos com eficiência. Para uma comparação detalhada, verifique o nosso white paper (relatório branco) de comparação.</p>
                                        </div>
                                    </div>
                                </div>
        
                                
                                <div class="card">
                                    <div class="card-header" id="QuestionGCTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCTwoContent" aria-expanded="true"
                                            aria-controls="QuestionGCTwoContent">Qual é a diferença entre os planos pagos Trinka dos demais verificadores gramaticais gratuitos?</a>
                                    </div>
        
                                    <div id="QuestionGCTwoContent" class="collapse"
                                        aria-labelledby="QuestionGCTwo" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Trinka não é um verificador gramatical típico. É uma excelente escolha para redação acadêmica e técnica. <b>O plano gratuito Trinka inclui mais recursos do que a maioria dos outros verificadores gramaticais premium.</b> Nosso plano premium tem um preço razoável e oferece mais recursos que atendem a todas as suas necessidades de escrita!</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="QuestionGCThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCThreeContent" aria-expanded="true"
                                            aria-controls="QuestionGCThreeContent">Em quais plataformas / aplicativos o verificador gramatical Trinka pode ser usado?</a>
                                    </div>
        
                                    <div id="QuestionGCThreeContent" class="collapse"
                                        aria-labelledby="QuestionGCThree" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p><b>O verificador gramatical Trinka pode ser usado em qualquer navegador da web.</b> Ele também está disponível como um plug-in <b>de navegador para os navegadores mais populares, como Chrome, Firefox, Safari e Edge, para ajudá-lo a obter correções gramaticais em seus sites favoritos.</b> Trinka também está disponível no suplemento MS Word para usuários premium.</p>
                                        </div>
                                    </div>
                                </div>
        
                                <div class="card">
                                    <div class="card-header" id="QuestionGCFour">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCFourContent" aria-expanded="true"
                                            aria-controls="QuestionGCFourContent">O verificador gramatical Trinka pode ser integrado ao meu software proprietário?</a>
                                    </div>
        
                                    <div id="QuestionGCFourContent" class="collapse"
                                        aria-labelledby="QuestionGCFour" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Trinka oferece uma variedade de opções fáceis de integrar. Você pode usar <b>Trinka JS para integrar o verificador gramatical em seu site,</b> simplesmente inserindo um trecho de código ou <b>usar Trinka API que permite integrar Trinka a qualquer um de seus produtos ou fluxos de trabalho existentes.</b></p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCFive">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCFiveContent" aria-expanded="true"
                                            aria-controls="QuestionGCFiveContent">Como verificar a redação on-line de graça?</a>
                                    </div>
        
                                    <div id="QuestionGCFiveContent" class="collapse"
                                        aria-labelledby="QuestionGCFive" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Use o Trinka para verificar sua redação on-line de graça. O Trinka é uma ferramenta avançada que usa inteligência artificial e torna o seu texto claro e fácil de entender. Com o Trinka, você pode verificar seu texto em relação a tudo, desde pequenos erros de pontuação e digitação até erros gramaticais sutis e problemas de construção de frases. Você pode verificar sua gramática de graça em qualquer lugar da Internet com o <a [routerLink]="['/browser-plugin']">plug-in do Trinka para navegadores</a> e também no MS Word, usando o add-in do Trinka para o Word.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCSix">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCSixContent" aria-expanded="true"
                                            aria-controls="QuestionGCSixContent">Como verificar se uma frase está gramaticalmente correta?</a>
                                    </div>
        
                                    <div id="QuestionGCSixContent" class="collapse"
                                        aria-labelledby="QuestionGCSix" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Para verificar se uma frase está gramaticalmente correta, basta colá-la no <b>verificador de ortografia e gramática</b> do Trinka. Ele fará uma verificação minuciosa da frase, procurando por erros de pontuação, gramática e vocabulário.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCSeven">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCSevenContent" aria-expanded="true"
                                            aria-controls="QuestionGCSevenContent">Como fazer verificação ortográfica no Twitter?</a>
                                    </div>
        
                                    <div id="QuestionGCSevenContent" class="collapse"
                                        aria-labelledby="QuestionGCSeven" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Basta instalar o <a [routerLink]="['/browser-plugin']">plug-in do Trinka no seu navegador</a> favorito e deixar que o Trinka verifique a gramática do seu tweet. Obtenha <b>verificação de gramática</b> instantânea em todo o Twitter.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCEight">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCEightContent" aria-expanded="true"
                                            aria-controls="QuestionGCEightContent">Como faço para verificar on-line meus erros de gramática no Word?</a>
                                    </div>
        
                                    <div id="QuestionGCEightContent" class="collapse"
                                        aria-labelledby="QuestionGCEight" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Instale o <a [routerLink]="['/wordplugin']">add-in do Trinka para o MS Word</a> e obtenha correções em tempo real. Além disso, o recurso de Edição Automática de Arquivos no add-in pode editar automaticamente o seu arquivo do MS Word com marcações de revisão. Você pode então baixar essas alterações do painel lateral do Word e finalizá-las. Torne-se um membro Premium para usar essa tecnologia poderosa e tornar a sua escrita clara e confiante.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCNine">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCNineContent" aria-expanded="true"
                                            aria-controls="QuestionGCNineContent">Como realmente funciona o verificador de gramática do Trinka?</a>
                                    </div>
        
                                    <div id="QuestionGCNineContent" class="collapse"
                                        aria-labelledby="QuestionGCNine" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>O <b>verificador de gramática</b> do Trinka usa algoritmos avançados de processamento de linguagem natural, que foram treinados com milhões de documentos de diferentes áreas. O Trinka também usa regras de gramática elaboradas manualmente que estão sempre sendo testadas e atualizadas para proporcionarem melhorias holísticas do conteúdo.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCTen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCTenContent" aria-expanded="true"
                                            aria-controls="QuestionGCTenContent">Como faço para verificar minha gramática no Google?</a>
                                    </div>
        
                                    <div id="QuestionGCTenContent" class="collapse"
                                        aria-labelledby="QuestionGCTen" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Basta instalar o <a [routerLink]="['/browser-plugin']">plug-in do Trinka para navegadores</a> para obter <b>verificações de gramática</b> instantâneas nos seus navegadores favoritos.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCeleven">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCelevenContent" aria-expanded="true"
                                            aria-controls="QuestionGCelevenContent">O quanto é precisa a verificação ortográfica do Trinka? </a>
                                    </div>
        
                                    <div id="QuestionGCelevenContent" class="collapse"
                                        aria-labelledby="QuestionGCeleven" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>O <b>verificador de gramática</b> do Trinka foi projetdo especificamente para conteúdo acadêmico. Por isso, é o melhor verificador gratuito de gramática para conteúdo acadêmico e técnico. Nossas avaliações em conjuntos de dados relevantes mostram que o Trinka geralmente consegue mais de 90% de precisão e mais de 80% de retorno.</p>
                                        </div>
                                    </div>
                                </div>
                                

                                <div class="card">
                                    <div class="card-header" id="QuestionGCTwelve">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCTwelveContent" aria-expanded="true"
                                            aria-controls="QuestionGCTwelveContent">O Trinka pode verificar a gramática em documentos do Word?</a>
                                    </div>
        
                                    <div id="QuestionGCTwelveContent" class="collapse"
                                        aria-labelledby="QuestionGCTwelve" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>O <a [routerLink]="['/wordplugin']">add-in do Trinka para o MS Word</a> oferece <b>verificações de gramática </b>gratuitas e instantâneas. Além disso, o recurso de Edição Automática de Arquivos edita automaticamente o seu documento do MS Word com marcações de revisão, que você pode então baixar e finalizar.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCThirteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCThirteenContent" aria-expanded="true"
                                            aria-controls="QuestionGCThirteenContent">O verificador gratuito de gramática do Trinka pode corrigir a estrutura das frases? </a>
                                    </div>
        
                                    <div id="QuestionGCThirteenContent" class="collapse"
                                        aria-labelledby="QuestionGCThirteen" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>O <b>verificador de gramática</b> gratuito do Trinka vai além das verificações de gramática e melhora a sua escrita quanto à estrutura, estilo, tom e muito mais.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCFouteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCFouteenContent" aria-expanded="true"
                                            aria-controls="QuestionGCFouteenContent">O verificador ortográfico e gramatical do Trinka pode ser acessado de graça?</a>
                                    </div>
        
                                    <div id="QuestionGCFouteenContent" class="collapse"
                                        aria-labelledby="QuestionGCFouteen" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>O <b>verificador de ortografia</b> e gramática do Trinka pode ser acessdo gratuitamente nesta página apenas até 300 palavras, mas com o Plano Básico você pode usá-lo até 10.000 palavras sem custo adicional.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCFivteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCFivteenContent" aria-expanded="true"
                                            aria-controls="QuestionGCFivteenContent">O Trinka pode ser usado para melhorar a gramática dos meus documentos?</a>
                                    </div>
        
                                    <div id="QuestionGCFivteenContent" class="collapse"
                                        aria-labelledby="QuestionGCFivteen" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>O Trinka vai além da gramática e da ortografia, e não apenas ajudará a melhorar a gramática do seu documento, mas também melhorará a qualidade da linguagem do seu documento de forma holística.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCSixteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCSixteenContent" aria-expanded="true"
                                            aria-controls="QuestionGCSixteenContent">O verificador de gramática on-line do Trinka pode ser usada para artigos acadêmicos?</a>
                                    </div>
        
                                    <div id="QuestionGCSixteenContent" class="collapse"
                                        aria-labelledby="QuestionGCSixteen" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Como o <b>verificador de gramática</b> do Trinka foi projetado especificamente para redação acadêmica, técnica e formal, ele é o melhor verificador on-line de gramática para artigos acadêmicos.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCSeventeen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCSeventeenContent" aria-expanded="true"
                                            aria-controls="QuestionGCSeventeenContent">O verificador gratuito de gramática do Trinka pode identificar erros de consistência?</a>
                                    </div>
        
                                    <div id="QuestionGCSeventeenContent" class="collapse"
                                        aria-labelledby="QuestionGCSeventeen" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>No <b>verificador de gramática</b> gratuito do Trinka, há um recurso incorporado chamado <a [routerLink]="['/features/consistency-check']">Verificador de Consistência</a>. Ele identifica 5 variações de inconsistências com um único clique.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCEighteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCEighteenContent" aria-expanded="true"
                                            aria-controls="QuestionGCEighteenContent">O verificador de gramática do Trinka pode verificar documentos do MS Word?</a>
                                    </div>
        
                                    <div id="QuestionGCEighteenContent" class="collapse"
                                        aria-labelledby="QuestionGCEighteen" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>O <b>verificador de gramática</b> do Trinka oferece um <a [routerLink]="['/wordplugin']">add-in para o MS Word</a>. O Trinka também tem um recurso de edição automática de arquivos, no qual seu documento é verificado automaticamente quanto a <b>erros de gramática</b> em segundos, e você obtém todas as sugestões nas marcações de revisão.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCNinteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCNinteenContent" aria-expanded="true"
                                            aria-controls="QuestionGCNinteenContent">O verificador de gramática on-line gratuito do Trinka pode ser acessado off-line?</a>
                                    </div>
        
                                    <div id="QuestionGCNinteenContent" class="collapse"
                                        aria-labelledby="QuestionGCNinteen" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>O <b>verificador de gramática</b> gratuito do Trinka precisa de uma conexão on-line ativa para dar sugestões em tempo real. </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGC20">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGC20Content" aria-expanded="true"
                                            aria-controls="QuestionGC20Content">Onde posso verificar se minha gramática está correta? </a>
                                    </div>
        
                                    <div id="QuestionGC20Content" class="collapse"
                                        aria-labelledby="QuestionGC20" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>O <b>verificador de gramática</b> gratuito e instantâneo do Trinka fará a revisão do seu texto automaticamente, para garantir que o texto esteja na forma mais adequada. Você pode clicar nas sugestões que aparecem para o texto sublinhado, para corrigir <b>erros de ortografia</b> e gramática ou aplicar sugestões de estilo.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGC21">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGC21Content" aria-expanded="true"
                                            aria-controls="QuestionGC21Content">Onde posso verificar minha gramática de graça?</a>
                                    </div>
        
                                    <div id="QuestionGC21Content" class="collapse"
                                        aria-labelledby="QuestionGC21" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Com o Plano Básico do Trinka, você pode <b>verificar sua gramática</b> gratuitamente em qualquer lugar da Internet com o <a [routerLink]="['/browser-plugin']" >plug-in do Trinka para navegadores</a>.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGC22">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGC22Content" aria-expanded="true"
                                            aria-controls="QuestionGC22Content">O verificador de gramática do Trinka dá explicações para suas correções de gramática? </a>
                                    </div>
        
                                    <div id="QuestionGC22Content" class="collapse"
                                        aria-labelledby="QuestionGC22" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Certamente que sim! O <b>verificador de gramática</b> do Trinka dá sugestões com explicações, para você aprender com os seus erros e fazer alterações bem embasadas no seu conteúdo.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGC23">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGC23Content" aria-expanded="true"
                                            aria-controls="QuestionGC23Content">O verificador de gramática do Trinka substitui a revisão manual?</a>
                                    </div>
        
                                    <div id="QuestionGC23Content" class="collapse"
                                        aria-labelledby="QuestionGC23" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>
                                                O que determina isso é a qualidade da redação original. Um revisor humano ajuda se você não falar inglês e cometer muitos erros complexos de construção lógica nesse idioma. O Trinka pode corrigir milhares de erros gramaticais e problemas complexos de escrita, mas a inteligência artificial tem limitações. Se a construção não for lógica, o Trinka não conseguirá decifrar o significado pretendido. Para autores com conhecimento suficiente da língua inglesa para construir frases logicamente corretas, o <b>verificador de gramática</b> do Trinka pode se encarregar do tom, escolha de palavras, construções gramaticais, ortografia e muito mais.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGC24">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGC24Content" aria-expanded="true"
                                            aria-controls="QuestionGC24Content">O verificador de gramática do Trinka verifica a pontuação?</a>
                                    </div>
        
                                    <div id="QuestionGC24Content" class="collapse"
                                        aria-labelledby="QuestionGC24" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Sim, o <b>verificador de gramática</b> do Trinka pode corrigir a pontuação e melhorar a qualidade do seu conteúdo.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGC25">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGC25Content" aria-expanded="true"
                                            aria-controls="QuestionGC25Content">O verificador de gramática Trinka Premium dá descontos para estudantes?</a>
                                    </div>
        
                                    <div id="QuestionGC25Content" class="collapse"
                                        aria-labelledby="QuestionGC25" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                           <p>O <b>verificador de gramática</b> do Trinka Premium pode ser acessado por estudantes com 20% de desconto. Escreva para <a href="mailto:support@trinka.ai">support@trinka.ai</a> para obter esse desconto.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGC26">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGC26Content" aria-expanded="true"
                                            aria-controls="QuestionGC26Content">O verificador de gramática do Trinka tem suporte a idiomas que não o inglês?</a>
                                    </div>
        
                                    <div id="QuestionGC26Content" class="collapse"
                                        aria-labelledby="QuestionGC26" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>O <b>verificador de gramática</b> do Trinka tem suporte apenas ao inglês. </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGC27">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGC27Content" aria-expanded="true"
                                            aria-controls="QuestionGC27Content">Em quais Web sites a ferramenta de verificação gramatical do Trinka funciona?</a>
                                    </div>
        
                                    <div id="QuestionGC27Content" class="collapse"
                                        aria-labelledby="QuestionGC27" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            
                                            <p>Use o <a [routerLink]="['/browser-plugin']">plug-in de navegador</a> do Trinka para o seu navegador preferido e desfrute do <b>verificador de gramática</b> gratuito do Trinka em todos os Web sites.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGC28">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGC28Content" aria-expanded="true"
                                            aria-controls="QuestionGC28Content">A ferramenta de verificação gramatical do Trinka dá suporte a quais aplicativos? </a>
                                    </div>
        
                                    <div id="QuestionGC28Content" class="collapse"
                                        aria-labelledby="QuestionGC28" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Depois de se inscrever no Plano Básico do Trinka e baixar o <a [routerLink]="['/browser-plugin']">plug-in de navegador</a> do Trinka, você poderá usá-lo em todos os Web sites e corrigir sua gramática em qualquer lugar, on-line. Você também poderá usar o <a [routerLink]="['/wordplugin']">add-in do Trinka</a> para o Word em documentos do MS Word.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGC29">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGC29Content" aria-expanded="true"
                                            aria-controls="QuestionGC29Content">Que tipos de erros de inglês o verificador de gramática do Trinka consegue corrigir? </a>
                                    </div>
        
                                    <div id="QuestionGC29Content" class="collapse"
                                        aria-labelledby="QuestionGC29" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Além da ortografia e gramática, o <b>verificador de gramática</b> do Trinka também corrige a pontuação, estrutura da frase, tom, etc., para melhorar o seu conteúdo.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGC30">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGC30Content" aria-expanded="true"
                                            aria-controls="QuestionGC30Content">O verificador de gramática do Trinka pode ser usado para verificar a gramática da minha tese?</a>
                                    </div>
        
                                    <div id="QuestionGC30Content" class="collapse"
                                        aria-labelledby="QuestionGC30" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Sim, o <b>verificador de gramática</b> do Trinka é excelente.para revisar documentos acadêmicos e técnicos. Recomendamos que você o use para teses, artigos de pesquisa, relatórios, ensaios e outros documentos formais.</p>
                                        </div>
                                    </div>
                                </div>
        
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="testimonail_demo_page">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="testimonail_heading">
                    <h2>Testimonials</h2>
                    <p>Check what users are saying about Trinka</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="../../../assets/images/quote_icons.png" alt="quote icon">
                    </div>
                    <p>The grammar checking tool exceeds Grammarly! I re-checked some documents that I had checked
                        earlier with Grammarly. I was pleasantly surprised to see such a product from India!</p>
                    <div class="testimonals_footer">
                        <p>Radiologist, India</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="../../../assets/images/quote_icons.png" alt="quote icon">
                    </div>
                    <p>First, I love Trinka. Congratulations on developing something that extensively aids editing,
                        especially critical grammar conventions and word count reductions.</p>
                    <div class="testimonals_footer">
                        <p>Academic Editor, USA</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-12">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="../../../assets/images/quote_icons.png" alt="quote icon">
                    </div>
                    <p>I have tested Trinka and am impressed with its fine capabilities. It did better than the grammar
                        checker I use. Well done! I have told my colleagues in my research lab to use Trinka. Hope it is
                        widely used in academia.</p>
                    <div class="testimonals_footer">
                        <p>PhD Scholar, UK</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<!-- Modal -->
<div class="modal fade" id="usageLimitExhausted" tabindex="-1" role="dialog" aria-labelledby="usageLimitExhaustedLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <button type="button" id="closedExceededPopup" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>

          <div class="upgradePremiumSection">
            <div class="upgradeHeaderSection">
               <div class="upgradeHeaderSection_overlay"></div>
               <h3>Opa! Limite de conteúdo excedido.</h3>
            </div>
            <div class="upgradeBodySection">
               <!-- <h2>Sign Up for free and get 5000 words/month</h2> -->
               <p style="margin: 0; margin-top: 10px;">Com uma conta Trinka gratuita, você pode verificar se está escrevendo até 10.000 palavras por mês. Tudo que você precisa fazer é se inscrever gratuitamente.</p>
               <!-- <p> All you need to do is Sign Up for free.</p> -->
               <div class="goupgradeButton">
                  <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">Cadastre-se aqui</a>
                  <button id="FooterClosedExceededPopup">Voltar para o editor</button>
               </div>
            </div>
         </div>
      </div>
    </div>
  </div>

   <!--Modal for accept limit exceeded-->
   <div class="modal fade" id="acceptedLimitExhausted" tabindex="-1" role="dialog" aria-labelledby="acceptedLimitExhaustedLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <button type="button" id="closedAcceptedLimitExhaustedPopup"   (click)="hideModal1()"  class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
         <div class="limitExhaustedBody">
             <div class="limitExhaustedLeftContent">
                 <div class="logoSection">
                     <img src="../../../assets/images/trinka-logo.png" alt="trinka logo">
                 </div>
                 <div class="ExhaustedLeftContent">
                     <h2>Mais correções de gramática e edições com um clique.</h2>
                     <a href="https://cloud.trinka.ai/signup?_rg=Grammar-Checker-JS-PT" target="_blank">Obtenha uma conta gratuita</a>
                 </div>
             </div>
             <div class="limitExhaustedRightContent">
                 <div class="rightInnerContent">
                     <img class="backgourndImageSection" src="../../../assets/images/home_banner.jpg" alt="gc checker">
                     <div class="imagesOverlaySection"></div>
                 </div>
                 <div class="ExhastedRightContainer">
                    <img src="../../../assets/images/GC_grammarCheckCard.png" class="grammarCheckCardImg" alt="gc card" >
                    <img src="../../../assets/images/GC_EnhanCheckCard.png" class="EnhanmentCheckCardImg" alt="gc check card" >
                    <a href="https://cloud.trinka.ai/signup?_rg=Grammar-Checker-JS-PT" target="_blank">Obtenha uma conta gratuita</a>
                </div>
             </div>
         </div>
      </div>
    </div>
  </div>